/* eslint-disable */
import { ComponentDefinition } from '../index';

declare var Object: any;
export interface ComponentStyleSheetDefinitionInterface {
  id?: string;
  key: string;
  default?: string;
  framework: string;
  description?: string;
  componentDefinitionId?: string;
  createdDate?: Date;
  createdBy?: string;
  createdById?: string;
  updatedDate?: Date;
  updatedBy?: string;
  updatedById?: string;
  componentDefinition?: ComponentDefinition;
}

export class ComponentStyleSheetDefinition
  implements ComponentStyleSheetDefinitionInterface {
  'id': string;
  'key': string;
  'default': string;
  'framework': string;
  'description': string;
  'componentDefinitionId': string;
  'createdDate': Date;
  'createdBy': string;
  'createdById': string;
  'updatedDate': Date;
  'updatedBy': string;
  'updatedById': string;
  componentDefinition: ComponentDefinition;
  constructor(data?: ComponentStyleSheetDefinitionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ComponentStyleSheetDefinition`.
   */
  public static getModelName() {
    return 'ComponentStyleSheetDefinition';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of ComponentStyleSheetDefinition for dynamic purposes.
   **/
  public static factory(
    data: ComponentStyleSheetDefinitionInterface
  ): ComponentStyleSheetDefinition {
    return new ComponentStyleSheetDefinition(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'ComponentStyleSheetDefinition',
      plural: 'ComponentStyleSheetDefinitions',
      path: 'component-style-sheet-definitions',
      idName: 'id',
      properties: {
        id: {
          name: 'id',
          type: 'string',
        },
        key: {
          name: 'key',
          type: 'string',
        },
        default: {
          name: 'default',
          type: 'string',
        },
        framework: {
          name: 'framework',
          type: 'string',
          default: 'angular',
        },
        description: {
          name: 'description',
          type: 'string',
        },
        componentDefinitionId: {
          name: 'componentDefinitionId',
          type: 'string',
        },
        createdDate: {
          name: 'createdDate',
          type: 'Date',
        },
        createdBy: {
          name: 'createdBy',
          type: 'string',
        },
        createdById: {
          name: 'createdById',
          type: 'string',
        },
        updatedDate: {
          name: 'updatedDate',
          type: 'Date',
        },
        updatedBy: {
          name: 'updatedBy',
          type: 'string',
        },
        updatedById: {
          name: 'updatedById',
          type: 'string',
        },
      },
      relations: {
        componentDefinition: {
          name: 'componentDefinition',
          type: 'ComponentDefinition',
          model: 'ComponentDefinition',
          relationType: 'belongsTo',
          keyFrom: 'componentDefinitionId',
          keyTo: 'id',
        },
      },
    };
  }
}
